/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect, useRef } from 'react';
import PrimaryCard from "../../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image } from "antd";
import { checkComponentPermission, currencyFormat } from "../../../../../../helpers/utilities";
import usePrevious from "../../../../../Shared/components/Previous";
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { verifySalesPrice, verifyPurchasePrice } from "../../../../../../config/constant";
import { TableCell, TableRow, Checkbox, TextField } from "@mui/material";


export const Verify = (props) => {
    const [iconAnimation, setIconAnimation] = useState(false);
    const { classes, clsx, loader, details, list, listAll, editLoader, handleValidate, roleManagement, handleSetList } = props;
    const [search, setSearch] = useState('');
    const prevSearch = usePrevious(search);
    const [purchasePrice, setPurchasePrice] = useState([]);
    const [selected, setSelected] = useState([]);
    const timeoutRef = useRef(null);

    const isSelected = (id) => selected.indexOf(id) !== -1;


    const handleClick = (id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected?.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                handleSetList(listAll);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    let d = listAll.filter((el) => {
                        return el[0]?.product?.productName?.match(new RegExp(search, "i"))
                    });
                    handleSetList(d);
                }, 500);
            }
        }
    }, [search]);


    useEffect(() => {
        if (list && list.length > 0) {
            const newSelecteds = list.filter((el) => { return el[1] === null }).map((n, i) => n[0].id);
            setSelected(newSelecteds);
            const newPurchasePrice = list.filter((el) => { return el[1] !== null });
            setPurchasePrice(newPurchasePrice);
        }
    }, [list]);

    const handleAccept = () => {
        var items = list.filter((el, i) => { return selected.find(e => e === el[0].id) });
        handleValidate('accept', items);
    }

    const handleSelected = (value) => {
        if (value.checked) {
            const newSelecteds = list.map((n, i) => n[0].id);
            setSelected(newSelecteds);
        } else {
            const newSelecteds = list.filter((el) => { return el[1] === null }).map((n, i) => n[0].id);
            setSelected(newSelecteds);
        }
    }

    return (
        <div className={clsx(classes.margin40, classes.listTableMargin)}>
            <PrimaryCard
                title={'Batch Verification'}
                component={
                    <>
                        <Row align="middle" className={classes.marginBottom20}>
                            <Col span={8}>
                                {
                                    roleManagement !== '' && checkComponentPermission('Inbound Price List', 'Page', 'Product Search') &&
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image src={SearchIcon} preview={false} />
                                    </div>
                                }
                                <div className={classes.verifyTitle}>
                                    <div>Batch ID <span>{details?.batchId}</span></div>
                                    <div className={classes.splitBar}></div>
                                    <div>Date <span>{moment(details?.createTs).format('DD MMM YYYY')}</span></div>
                                </div>
                            </Col>
                            <Col span={16} className={clsx(classes.textAlignRight, classes.customerLabelNone)}>
                                {
                                    selected?.length > 0 && <NavLink to={'#'}
                                        onClick={() => handleAccept()}
                                        className={clsx(classes.modalBtn, { [classes.loadingA]: editLoader })}>
                                        Accept
                                    </NavLink>
                                }
                            </Col>
                        </Row>
                        <Row gutter={30} className={clsx(classes.scrollParent, classes.scrollParentVerify)}>
                            <Col span={12} className={classes.scrollParentSettleMent}>
                                <h6 className={clsx(classes.typographyHeader, classes.bold)}>Sales Price</h6>
                                <CustomInfiniteScroll
                                    loadMore={loader}
                                    loadMoreContent={false}
                                    heads={verifySalesPrice}
                                    autoWidth={true}
                                    selected={selected}
                                    onCheckCheckBox={(value) => handleSelected(value)}
                                    details={list}
                                    component={<>
                                        {
                                            loader ? (
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={verifySalesPrice?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>) : (
                                                <React.Fragment>
                                                    {
                                                        list && Array.isArray(list) && list?.length > 0 ? list?.map((data, i) => (
                                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                <TableCell style={{ verticalAlign: "top" }} className={clsx('checkbox', classes.tablealign)} padding="checkbox"><Checkbox onChange={(e) => { if (data[1]) { handleClick(data[0]?.id) } }} color="primary"
                                                                    checked={isSelected(data[0].id)} /></TableCell>
                                                                <TableCell style={{ verticalAlign: "top" }}>
                                                                    <div className={classes.verifyFirstCol}>
                                                                        <div className={clsx(classes.color, classes.bold)}>{data[0]?.product?.productName || '---'}</div>
                                                                        {
                                                                            data[1] ? <span className={clsx(classes.new, classes.exist)}>Exist</span> : <span className={clsx(classes.new)}>New</span>
                                                                        }
                                                                        <div className={clsx(classes.disPlaySpaceEven, classes.margin20t)}>
                                                                            <div className={classes.textAreaLableColorUpload}>Universal Product ID</div>
                                                                            <div className={classes.textAreaLableColorUpload}>Unit</div>
                                                                        </div>
                                                                        <div className={clsx(classes.disPlaySpaceEven, classes.margin10t)}>
                                                                            <div>{data[0]?.product?.universalProduct?.productId || '----'}</div>
                                                                            <div>{data[0]?.unit?.name || '---'}</div>
                                                                        </div>
                                                                    </div>
                                                                </TableCell>
                                                                <TableCell style={{ verticalAlign: "top" }} className={classes.textAlignRight}>
                                                                    <div>{`₹ ${currencyFormat(data[0]?.price || 0)}`}</div>
                                                                    <div className={clsx(classes.margin20t, classes.textAreaLableColorUpload)}>From Date</div>
                                                                    <div className={classes.margin10t}>{data[0]?.fromDate ? moment(data[0].fromDate).format('DD MMM YYYY') : '---'}</div>
                                                                </TableCell>
                                                                <TableCell style={{ verticalAlign: "top" }} className={classes.textAlignRight}>
                                                                    <div>{data[0]?.maxRetailPrice ? `₹ ${currencyFormat(data[0]?.maxRetailPrice)}` : '---'}</div>
                                                                    <div className={clsx(classes.margin20t, classes.textAreaLableColorUpload)}>To Date</div>
                                                                    <div className={classes.margin10t}>{data[0]?.toDate ? moment(data[0].toDate).format('DD MMM YYYY') : '---'}</div>
                                                                </TableCell>
                                                            </TableRow>
                                                        )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell className={classes.textAlignCenter} colSpan={verifySalesPrice.length}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Currently there is no existing Sales Price in the system'}</p></TableCell>
                                                        </TableRow>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                    </>
                                    }
                                />
                            </Col>
                            <Col span={12}>
                                <h6 className={clsx(classes.typographyHeader, classes.bold)}>Purchase Price</h6>
                                <CustomInfiniteScroll
                                    loadMore={loader}
                                    loadMoreContent={false}
                                    heads={verifyPurchasePrice}
                                    autoWidth={true}
                                    selected={selected}
                                    onSelected={(value) => setSelected(value)}
                                    component={<>
                                        {
                                            loader ? (
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell className={classes.textAlignCenter} colSpan={verifySalesPrice?.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                                </TableRow>) : (
                                                <React.Fragment>
                                                    {
                                                        list && Array.isArray(list) && purchasePrice?.length > 0 ? list?.map((data, i) => (
                                                            <>
                                                                {
                                                                    data[1] === null ? '' : <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                        <TableCell style={{ verticalAlign: "top" }}>
                                                                            <div className={classes.verifyFirstCol}>
                                                                                <div className={clsx(classes.color, classes.bold)}>{data[1]?.product?.productName || '---'}</div>
                                                                                <div className={clsx(classes.disPlaySpaceEven, classes.margin20t)}>
                                                                                    <div className={classes.textAreaLableColorUpload}>Price ID</div>
                                                                                    <div className={classes.textAreaLableColorUpload}>Unit</div>
                                                                                </div>
                                                                                <div className={clsx(classes.disPlaySpaceEven, classes.margin10t)}>
                                                                                    <div>{data[1]?.product?.universalProduct?.productId || '----'}</div>
                                                                                    <div>{data[1]?.unit?.name || '---'}</div>
                                                                                </div>
                                                                            </div>
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: "top" }}>
                                                                            <div>{data[1]?.supplier?.name || '---'}</div>
                                                                            <div className={clsx(classes.margin20t, classes.textAreaLableColorUpload)}>From Date</div>
                                                                            <div className={classes.margin10t}>{data[1]?.fromDate ? moment(data[1].fromDate).format('DD MMM YYYY') : '---'}</div>
                                                                        </TableCell>
                                                                        <TableCell style={{ verticalAlign: "top" }} className={classes.textAlignRight}>
                                                                            <div>{data[1]?.price ? `₹ ${currencyFormat(data[1]?.price)}` : '---'}</div>
                                                                            <div className={clsx(classes.margin20t, classes.textAreaLableColorUpload)}>To Date</div>
                                                                            <div className={classes.margin10t}>{data[1]?.toDate ? moment(data[1].toDate).format('DD MMM YYYY') : '---'}</div>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                }
                                                            </>

                                                        )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                            <TableCell className={classes.textAlignCenter} colSpan={verifySalesPrice.length}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Currently there is no existing Purchase Price in the system'}</p></TableCell>
                                                        </TableRow>
                                                    }
                                                </React.Fragment>
                                            )
                                        }
                                    </>
                                    }
                                />
                            </Col>
                        </Row>
                    </>
                }
            />
        </div>
    )
}